import React, { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ThemeToggle from './ThemeToggle';
import NotificationBell from './NotificationBell';
import InstallPrompt from './InstallPrompt';
import { LayoutDashboard, Users, BarChart3, Settings, LogOut, Menu, X, Wallet, Building2, Receipt, RefreshCw, TrendingDown, Repeat, FileSignature, KanbanSquare, Compass } from 'lucide-react';
import BrandAvatar from './BrandAvatar';
import { SECCIONES } from '../pages/admin/AdminSettings';

// el mismo degradé de marca que usan los portales
const DEGRADE = 'linear-gradient(160deg, #0B1C33 0%, #14487F 58%, #2E7DE2 100%)';
const BORDE = '1px solid rgba(255,255,255,0.12)';

const navItems = [
  { grupo: 'Agencia' },
  { to: '/agencia', icon: Wallet, label: 'Panel', end: true },
  { to: '/agencia/clientes', icon: Building2, label: 'Clientes' },
  { to: '/agencia/propuestas', icon: FileSignature, label: 'Propuestas' },
  { to: '/agencia/proyectos', icon: KanbanSquare, label: 'Proyectos' },
  { to: '/agencia/cobros', icon: Receipt, label: 'Cobros' },
  { to: '/agencia/abonos', icon: Repeat, label: 'Abonos' },
  { to: '/agencia/renovaciones', icon: RefreshCw, label: 'Hosting' },
  { to: '/agencia/egresos', icon: TrendingDown, label: 'Egresos' },
  { to: '/agencia/reportes', icon: BarChart3, label: 'Reportes' },
  { to: '/agencia/planificacion', icon: Compass, label: 'Planificación' },
  { grupo: 'CRM' },
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/clients', icon: Users, label: 'Clientes CRM' },
  { to: '/reports', icon: BarChart3, label: 'Reportes CRM' },
  { grupo: '' },
  { to: '/settings', icon: Settings, label: 'Configuración' },
];

export default function AdminLayout() {
  const { logout, user, theme, setTheme } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const enConfig = location.pathname.startsWith('/settings');   // ahí desplegamos los subítems
  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      <button onClick={() => setMobileOpen(!mobileOpen)} className="mobile-menu-btn" style={{ position:'fixed', top:12, left:12, zIndex:1001, background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:8, padding:8, color:'var(--text-primary)', display:'none' }}>{mobileOpen ? <X size={20}/> : <Menu size={20}/>}</button>
      {mobileOpen && <div style={{position:'fixed',inset:0,background:'var(--overlay)',zIndex:998}} onClick={()=>setMobileOpen(false)}/>}
      <aside className="sidebar" style={{ width:250, minWidth:250, height:'100vh', background:DEGRADE, display:'flex', flexDirection:'column', position: mobileOpen ? 'fixed' : 'relative', zIndex:999 }}>
        <div style={{ padding:'24px 20px', borderBottom:BORDE }}>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <BrandAvatar src="/uploads/agencia/logo.png" name="Udream" size={48} />
            <div className="sidebar-brand-text" style={{ minWidth:0 }}>
              <div style={{ fontSize:15, fontWeight:800, color:'#fff', lineHeight:1.2 }}>Udream</div>
              <div style={{ display:'flex', alignItems:'center', gap:6, marginTop:4, fontSize:11, color:'rgba(255,255,255,0.6)', fontWeight:600 }}>
                <img src="/favicon-32x32.png?v=2" alt="" style={{ width:20, height:20, borderRadius:5, border:'1px solid rgba(255,255,255,0.7)' }} /> Udream App
              </div>
            </div>
          </div>
        </div>
        <nav style={{ flex:1, padding:'12px 10px', display:'flex', flexDirection:'column', gap:2, overflowY:'auto' }}>
          {navItems.map(item => item.grupo !== undefined ? (
            <div key={'g' + item.grupo} style={{ fontSize:10, fontWeight:700, letterSpacing:1, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', padding:'12px 14px 4px' }}>{item.grupo}</div>
          ) : (<NavLink key={item.to} to={item.to} end={item.end} onClick={() => setMobileOpen(false)} style={({ isActive }) => ({ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderRadius:10, fontSize:14, fontWeight: isActive ? 700 : 500, color: isActive ? '#0B1C33' : 'rgba(255,255,255,0.8)', background: isActive ? '#fff' : 'transparent', textDecoration:'none', transition:'all 0.15s' })}><item.icon size={18}/> {item.label}</NavLink>))}
          {enConfig && SECCIONES.map(s => (
            <NavLink key={s.key} to={'/settings#' + s.key} onClick={() => setMobileOpen(false)}
              style={() => {
                const activo = (location.hash || '#medios-pago').replace('#', '') === s.key;
                return { display:'block', padding:'7px 14px 7px 44px', borderRadius:8, fontSize:13, textDecoration:'none',
                  fontWeight: activo ? 700 : 500, color: activo ? '#fff' : 'rgba(255,255,255,0.65)',
                  background: activo ? 'rgba(255,255,255,0.14)' : 'transparent' };
              }}>{s.label}</NavLink>
          ))}
        </nav>
        <div style={{ padding:'16px', borderTop:BORDE }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
            <div style={{ minWidth:0, flex:1 }}>
              <div style={{ fontSize:13, color:'#fff', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.display_name || user?.username}</div>
              <div style={{ fontSize:11, color:'rgba(255,255,255,0.55)' }}>Administración</div>
            </div>
            <ThemeToggle theme={theme} onChange={setTheme} color="rgba(255,255,255,0.8)" />
          </div>
          <button onClick={logout} className="btn btn-ghost" style={{ width:'100%', justifyContent:'flex-start', gap:8, color:'rgba(255,255,255,0.8)' }}><LogOut size={16}/> Cerrar sesión</button>
        </div>
      </aside>
      <main style={{ flex:1, overflow:'auto', padding:28 }}><Outlet/></main>

      <NotificationBell />
      <InstallPrompt />
      <style>{`@media (max-width: 768px) { .sidebar { position: fixed !important; transform: translateX(${mobileOpen ? '0' : '-100%'}) !important; transition: transform 0.25s; } .mobile-menu-btn { display: block !important; } main { padding: 16px !important; padding-top: 56px !important; } .sidebar > div:first-child { padding-top: 56px !important; } }`}</style>
    </div>
  );
}
